import { testimonials } from "@/mocks/home";

export default function Testimonials() {
  return (
    <section className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto mb-10 md:mb-14">
          <span className="inline-block text-primary-600 text-sm font-semibold uppercase tracking-wider mb-3">
            Testimoni
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
            Kata Mereka Yang Kami Bantu
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t) => (
            <div
              key={t.id}
              className="bg-background-50 rounded-lg p-6 md:p-7 border border-background-200 flex flex-col"
            >
              <span className="text-accent-500 mb-4">
                <i className="ri-double-quotes-l text-3xl"></i>
              </span>
              <p className="text-sm text-foreground-700 leading-relaxed flex-1">
                {t.quote}
              </p>
              <div className="mt-6 flex items-center gap-3">
                <span className="w-11 h-11 flex items-center justify-center rounded-full bg-primary-100 text-primary-700 font-semibold text-sm">
                  {t.initials}
                </span>
                <div>
                  <p className="font-semibold text-sm text-foreground-900">
                    {t.name}
                  </p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}